import { render } from "./CategoryComponent.vue?vue&type=template&id=55496c62&scoped=true"
import script from "./CategoryComponent.vue?vue&type=script&lang=js"
export * from "./CategoryComponent.vue?vue&type=script&lang=js"

import "./CategoryComponent.vue?vue&type=style&index=0&id=55496c62&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55496c62"]])

export default __exports__